angular.module('impactx.search').controller('ContactSearchListCtrl', [
    'SearchFilter',
    ContactSearchListController
]);

function ContactSearchListController(SearchFilter) {
    var self = this;
    self.nameSort = 0;
    SearchFilter.resetSort();

    self.sortByName = function () {
        self.nameSort = SearchFilter.sortByName(true);
        search();
    };

    function search() {
        self.containerCtrl.updateContent(1, SearchFilter.getSelectedSort(self.nameSort));
    }
}
